import { render, staticRenderFns } from "./TabDuplication.vue?vue&type=template&id=3491d59f&"
import script from "./TabDuplication.vue?vue&type=script&lang=js&"
export * from "./TabDuplication.vue?vue&type=script&lang=js&"
import style0 from "./TabDuplication.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports